import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { User } from '../User';
export class OrganizationAdmins extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.users = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(User) })
], OrganizationAdmins.prototype, "users", void 0);
//# sourceMappingURL=OrganizationAdmins.js.map